"use client";

import React from "react";

import NoDataImage from "@/assets/error/no-data-found.jpg";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import pxToRem from "@/themes/functions/pxToRem";

type AlertBlockProps = {
  src?: string;
  title: string;
  description?: string;
  alt: string;
  textPosition?: "above" | "below";
};

function AlertBlock({
  src = NoDataImage,
  title,
  description,
  alt,
  textPosition = "below",
}: AlertBlockProps) {
  const textContent = (
    <>
      <MDTypography
        sx={({ typography }) => ({ fontWeight: typography.fontWeightBold, textAlign: "center" })}
      >
        {title}
      </MDTypography>
      {description && (
        <MDTypography variant="caption" textAlign={"center"}>
          {description}
        </MDTypography>
      )}
    </>
  );

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={pxToRem(8)}
      p={1}
    >
      {textPosition === "above" && textContent}
      <img width={208} height={208} src={src} alt={alt} />
      {textPosition === "below" && textContent}
    </MDBox>
  );
}

export default AlertBlock;
